export const CARD_IDENTIFICATION_STATUS = {
  INIT: 'init',
  SUCCESS: 'success',
  NOT_SUCCESS: 'notSuccess',
  FAILED: 'failed',
} as const;

export const CARD_STATUS = {
  ANONYMOUS: 'anonymous',
  SIMPLY_IDENTIFIED: 'simplyIdentified',
} as const;

export const CHECK_PAYMENT_CODE = {
  OK: 'OK',
  OPERATION_LIMIT_REACHED: 'OPERATION_LIMIT_REACHED',
  MONTH_LIMIT_REACHED: 'MONTH_LIMIT_REACHED',
  NOT_ENOUGH_BALANCE: 'NOT_ENOUGH_BALANCE',
  NO_CARD: 'NO_CARD',
} as const;

export const PIN_CODES = {
  PIN_SENT: 'PIN_SENT',
  PIN_NOT_NEEDED: 'PIN_NOT_NEEDED',
} as const;

export const MODAL_TYPES = {
  AUTH: 'auth',
  RELEASE: 'release',
  UPGRADE: 'upgrade',
  REFILL: 'refill',
  NOT_ENOUGH_BALANCE: 'notEnough',
  TRANSFER: 'transfer',
  DETAILS: 'details',
} as const;
